import { DatePicker, Input } from 'antd';
import { DEFAULT_FORMAT_DATE_INPUT_US, FORMAT_DATE } from 'constants/days';
import deviceSizes from 'constants/deviceSizes';
import useWindowSize from 'hooks/useWindowSize';
import moment, { Moment } from 'moment';
import React, { ChangeEvent, useMemo } from 'react';
import styled from 'styled-components';

import { ICommonInputProps } from './types';

const InputStyled = styled(Input)`
  width: 100%;
  &::-webkit-calendar-picker-indicator {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    outline: none;
  }
`;

const DatePickerInput: React.FC<ICommonInputProps> = ({
  name,
  inputClassName,
  // defaultValue,
  inputSettings,
  disabled,
  onChange,
  value,
  onBlur,
}) => {
  const { isMobile } = useWindowSize(deviceSizes.numbers.md);
  const disabledDate = (current: Moment) =>
    // Can not select days before today and today
    current && current < moment().startOf('day');

  const handleChange = (_: Moment | null, dateString: string) => {
    const convertedDateString = dateString
      ? moment(dateString, DEFAULT_FORMAT_DATE_INPUT_US).format(FORMAT_DATE)
      : undefined;
    onChange?.(convertedDateString);
    // field.onChange(e);
  };

  const handleChangeMobileVer = (event: ChangeEvent<HTMLInputElement>) => {
    const dateString = moment(event.target.value).format(FORMAT_DATE);
    onChange?.(dateString);
    // field?.onChange(event.target.value, name);
  };

  // const momentDefaultValue = useMemo(() => {
  //   if (!defaultValue) return undefined;
  //   const tempDefaultValue = moment(defaultValue, DEFAULT_FORMAT_DATE_INPUT_US);
  //   if (tempDefaultValue.isValid()) return tempDefaultValue;
  //   return moment(defaultValue, FORMAT_DATE);
  // }, [defaultValue]);

  const [momentValue, dateFormat] = useMemo(() => {
    if (!value) return [undefined, undefined];
    const tempValue = moment(value, DEFAULT_FORMAT_DATE_INPUT_US);
    if (tempValue.isValid()) return [tempValue, DEFAULT_FORMAT_DATE_INPUT_US];
    return [moment(value, FORMAT_DATE), FORMAT_DATE];
  }, [value]);

  return (
    <>
      {isMobile ? (
        <InputStyled
          type='date'
          name={name}
          placeholder='Select date...'
          value={momentValue ? momentValue.format(FORMAT_DATE) : undefined}
          // defaultValue={momentDefaultValue ? momentDefaultValue.format(FORMAT_DATE) : undefined}
          className={`date-picker-input ${inputClassName}`}
          min={inputSettings?.disabledPastDate ? moment().format(FORMAT_DATE) : undefined}
          onChange={handleChangeMobileVer}
          disabled={disabled}
          onBlur={onBlur}
        />
      ) : (
        <DatePicker
          style={{ width: '100%' }}
          disabledDate={inputSettings?.disabledPastDate ? disabledDate : undefined}
          className={`date-picker-input ${inputClassName}`}
          onChange={handleChange}
          value={momentValue}
          format={[DEFAULT_FORMAT_DATE_INPUT_US, dateFormat || FORMAT_DATE]}
          disabled={disabled}
          onBlur={onBlur}
        />
      )}
    </>
  );
};

export default React.memo(DatePickerInput);
